module.exports = __webpack_public_path__ + "static/media/Pranav_Patel.09db4837.pdf";